import { render, staticRenderFns } from "./kehuInfo.vue?vue&type=template&id=536c45f9&"
import script from "./kehuInfo.vue?vue&type=script&lang=js&"
export * from "./kehuInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports